import { ProductType } from "@obg/ngx.core";

import {
	CASINO_ROUTES,
	LIVE_CASINO_ROUTES,
	POKER_ROUTES,
	SKILL_GAMES_ROUTES,
	SLOTS_ROUTES,
	TURKISH_POKER_ROUTES,
	VIRTUAL_SPORTS_ROUTES,
} from "../route";

export function isRouteGameLauncher(routeName: string): boolean {
	return (
		routeName === CASINO_ROUTES.gameLauncher ||
		routeName === LIVE_CASINO_ROUTES.gameLauncher ||
		routeName === VIRTUAL_SPORTS_ROUTES.gameLauncher ||
		routeName === POKER_ROUTES.gameLauncher ||
		routeName === TURKISH_POKER_ROUTES.gameLauncher ||
		routeName === SLOTS_ROUTES.gameLauncher ||
		routeName === SKILL_GAMES_ROUTES.gameLauncher
	);
}

export function isRouteGameCategory(routeName: string): boolean {
	return (
		routeName === CASINO_ROUTES.categories ||
		routeName === LIVE_CASINO_ROUTES.categories ||
		routeName === POKER_ROUTES.categories ||
		routeName === SLOTS_ROUTES.categories ||
		routeName === SKILL_GAMES_ROUTES.categories
	);
}

export function isProductGaming(product: string): boolean {
	return (
		product === ProductType.Casino ||
		product === ProductType.LiveCasino ||
		product === ProductType.VirtualSports ||
		product === ProductType.Poker ||
		product === ProductType.TurkishPoker ||
		product === ProductType.Slots ||
		product === ProductType.SkillGames
	);
}
